/*eslint-disable */
import React, { Component } from "react";
import ShipmentHeader from "../../components/shipmentComponent/shipmentHeader";
import { Image } from "semantic-ui-react";
import ShipmentGridView from "../../components/shipmentComponent/shipmentGridView";
import { readShipmentDispatcher } from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
//import Orders from "../../components/orderComponent/orders";
import OrderAggrid from "../../components/orderComponent/orderAGgrid";
import ReadAxios from "../../components/axiosComponent/read";
import AsyncAgGridTable from "../../components/common/asyncAgGridTable";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";

Object.defineProperty(Array.prototype, "chunk", {
  value: function (chunkSize) {
    var R = [];
    for (var i = 0; i < this.length; i += chunkSize)
      R.push(this.slice(i, i + chunkSize));
    return R;
  },
});
class Shipment extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      grid: (localStorage.getItem("customerNumber") == 1122 || localStorage.getItem("customerNumber") == 1123) ? true : false,
      loadingData: true,
      prevProps: [],
      // ag-grid async call
      locales: props.locales.local,
      rowData: [],
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      currentPageNumber: -1,
      agGridPageSize: 10,
      componentRenderKey: 0,
    };
  }

  async componentDidMount() {
    // this.props.read();
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log('this.state.locales', this.state.locales, nextProps.locales.local);
  //   if (this.state.locales == nextProps.locales.local) {
  //     this.setState({ locales: nextProps.locales.local }, () =>
  //       this.agGridAsyncCalls(nextProps)
  //     );
  //   }
  // }

  // agGridAsyncCalls(nextProps) {
  //   if (this.state.rowData.length != 0) {
  //     this.state.rowData = [];
  //   }
  //   if (
  //     nextProps.shipment &&
  //     JSON.stringify(this.state.rowData) !==
  //       JSON.stringify(nextProps.shipment.read)
  //   ) {
  //     const { componentRenderKey } = this.state;
  //     this.setState(
  //       {
  //         loadingData: false,
  //         prevProps: nextProps.shipment.read.chunk(5),
  //         rowData: nextProps.shipment.read,
  //         componentRenderKey: componentRenderKey + 1,
  //       },
  //       () => console.log("set state 115")
  //     );
  //   } else {
  //     this.setState(
  //       {
  //         loadingData: false,
  //         rowData: [],
  //         prevProps: [],
  //       },
  //       () => console.log("set loading false")
  //     );
  //   }
  // }

  // OnpaginationChangeCallback = (event) => {
  //   let apiDataJSON = [];
  //   const agGridPageSize = event.api.paginationProxy.pageSize;
  //   const agGridCurrentPage = event.api.paginationProxy.currentPage;
  //   const agGridPageTotalData = this.state.rowData;
  //   const agGridPageinationData = agGridPageTotalData.chunk(agGridPageSize);
  //   const agGridCurrentPageData = agGridPageinationData[agGridCurrentPage];
  //   // prepare data to make api call and merge it with row Data
  //   apiDataJSON = agGridCurrentPageData.map((item) => {
  //     return {
  //       route_id: item.route_id,
  //       vehicle_id: item.proposed_vehicle_type,
  //     };
  //   });
  //   let agGridCurrentPageFetch = [];
  //   apiDataJSON.map(async (item, index) => {
  //     let routeManager =
  //       (await ReadAxios({ url: `routeManager/${item.route_id}` })) || [];
  //     let vehicleTypeManager = []
  //       // (await ReadAxios({ url: `vehicleTypeMaster/${item.vehicle_id}` })) || [];
  //     routeManager = isEmpty(routeManager) ? [] : routeManager.data.resultSet;
  //     vehicleTypeManager = isEmpty(vehicleTypeManager)
  //       ? []
  //       : vehicleTypeManager.data.resultSet;
  //     agGridCurrentPageFetch.push({
  //       source: routeManager[0].checkPointName,
  //       destination: routeManager[routeManager.length - 1].checkPointName,
  //       vehicle_type: vehicleTypeManager[0]
  //         ? vehicleTypeManager[0].vehicleType
  //         : "",
  //     });

  //     if (
  //       agGridCurrentPageFetch.length == agGridCurrentPageData.length &&
  //       JSON.stringify(this.state.paginationCallbackData) !=
  //         JSON.stringify(agGridCurrentPageFetch)
  //     ) {
  //       const { componentRenderKey } = this.state;
  //       this.setState(
  //         {
  //           paginationCallbackData: agGridCurrentPageFetch,
  //           chunkedRowData: agGridPageinationData,
  //           currentPageData: agGridCurrentPageData,
  //           currentPageNumber: agGridCurrentPage,
  //           agGridPageSize: agGridPageSize,
  //           componentRenderKey: componentRenderKey + 1,
  //         },
  //         () => {
  //           console.log("set state 161");
  //           this.mergeTheCallbackDataWithRowData();
  //         }
  //       );
  //     }
  //   });
  // };

  // mergeTheCallbackDataWithRowData = () => {
  //   let currentPageNumber = this.state.currentPageNumber;
  //   let pageSize = this.state.agGridPageSize;
  //   let rowData = this.state.rowData;
  //   let currnetFetchData = this.state.paginationCallbackData;
  //   let currentPageData = this.state.currentPageData;
  //   let tempRowData = currentPageData.map((item, index) => {
  //     return Object.assign({}, item, currnetFetchData[index]);
  //   });
  //   let startIndex = currentPageNumber * pageSize;
  //   rowData.splice(startIndex, pageSize, ...tempRowData);
  //   const { componentRenderKey } = this.state;
  //   this.setState(
  //     {
  //       rowData: rowData,
  //       componentRenderKey: componentRenderKey + 1,
  //     },
  //     () => console.log("set state 147")
  //   );
  // };

  handleGridView = () => {
    const { componentRenderKey } = this.state;
    this.setState(
      {
        loadingData: false,
        grid: !this.state.grid,
        componentRenderKey: componentRenderKey + 1,
      },
      () => console.log("set state 185")
    );
  };

  redirectToOrderReports = ()=> {
    this.props.history.push({
      pathname: "/reportsheet?ORDERS_REPORT"
    });
    window.location.reload()
  }

  handleChange = (e) => {
    console.log('check search', e.target.value);
    this.setState({ searchValue: e.target.value });
  };

  // onRowEdit = (rowData) => {
  //   this.props.history.push("/edit-shipment", {
  //     ...rowData,
  //     title: "Edit Shipment",
  //   });
  // };

  // onRowDelete = () => {
  //   this.props.history.push("/shipment");
  //   this.props.history.go();
  // };

  // redirectToShipmentDetail = (item) => {
  //   let shipment = item[0];
  //   this.props.history.push({
  //     pathname: "/shipment-details",
  //     state: { item: { ...shipment } },
  //     search: `?shipmentId=${shipment.vendor_shipment_id}`,
  //   });
  // };

  render() {
    const { t } = this.props;
    const { grid, rowData, componentRenderKey } = this.state;
    // const columnDefs = [
    //   {
    //     headerName: t("table_view.reference_no") || "Reference Number",
    //     field: "shipment_reference_no",
    //     sortable: true,
    //     filter: true,
    //   },
    //   {
    //     headerName: t("table_view.source") || "Source",
    //     field: "source",
    //     sortable: true,
    //     filter: true,
    //   },
    //   {
    //     headerName: t("table_view.destination") || "Destination",
    //     field: "destination",
    //     sortable: true,
    //     filter: true,
    //   },
    // {
    //   headerName: t("table_view.alloted_veh") || "Alloted Veh.",
    //   field: "alloted_vehicle",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.required_on") || "Requirement Date",
    //   field: "required_on",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.required_veh") || "Required Veh.",
    //   field: "no_of_vehicles",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.movement_type") || "Movement Type",
    //   field: "movement_type",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.created_on") || "Created On",
    //   field: "created_on",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.vehicle_type") || "Vehicle Type",
    //   field: "vehicle_type",
    //   sortable: true,
    //   filter: true,
    // },
    // {
    //   headerName: t("table_view.edit_delete") || "Edit / Delete",
    //   field: "edit",
    //   cellRenderer: "actionRenderer",
    //   suppressToolPanel: true,
    // },
    // ];

    return (
      <React.Fragment>
        {/* {!grid && ( */}
        {/* <ShipmentHeader
            LinkName="/add-shipment"
            toggleView={this.handleGridView}
            handleSearch={this.handleChange}
            title={t("title") || "Shipment"}
            toggle={!this.state.grid}
          /> */}
        {/* )} */}
        {grid ? (
          // <AsyncAgGridTable
          //   isLoading={this.state.loadingData}
          //   columnDefs={columnDefs}
          //   rowData={rowData}
          //   titleBarTitle={t("title") || "Shipment"}
          //   titleBarLink={"/add-shipment"}
          //   baseURL={"shipments"}
          //   keyIndex={"u_id"}
          //   onEdit={this.onRowEdit}
          //   onDelete={this.onRowDelete}
          //   radioToggle={true}
          //   exportHidden={true}
          //   toggleView={this.handleGridView}
          //   toggle={!this.state.grid}
          //   suppressRowClickSelection={true}
          //   headerCheckboxSelection={true}
          //   headerCheckboxSelectionFilteredOnly={true}
          //   checkboxSelection={true}
          //   pegination={10}
          //   pageChangeCallback={true}
          //   OnpaginationChangeCallback={this.OnpaginationChangeCallback}
          //   currentPageNumber={this.state.currentPageNumber}
          //   redirectToShipmentDetail={this.redirectToShipmentDetail}
          // />
          <OrderAggrid {...this.props} title={+localStorage.getItem("customerNumber") == 503 ? "Bookings" : t("title") || "Orders"} toggleView={this.handleGridView} toggle={!this.state.grid}  redirectToOrderReports={this.redirectToOrderReports} />
        ) : (
          <ShipmentGridView
            toggleView={this.handleGridView}
            toggle={!this.state.grid}
            title={+localStorage.getItem("customerNumber") == 503 ? "Bookings" : t("title") || "Orders"}
            shipmentData={this.state.prevProps}
            isLoading={this.state.loadingData}
            redirectToOrderReports={this.redirectToOrderReports}
          />
        )}

        {rowData.length > 0 ? (
          <div
            className="life-cycle w3-white"
            style={{ position: "relative", marginTop: "2em" }}
          >
            {/* <Image
              className="ml-5 pl-5 pt-3 pb-3"
              src="assets/img/ta_life.png"
            /> */}
          </div>
        ) : (
          <div className="life-cycle w3-white">
            {/* <Image
              className="ml-5 pl-5 pt-3 pb-3"
              src="assets/img/ta_life.png"
            /> */}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shipment, locales }) => {
  return {
    shipment,
    locales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    read: () => dispatch(readShipmentDispatcher()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("shipment")(Shipment));
